import { render, staticRenderFns } from "./SelectRow.vue?vue&type=template&id=2a8b597e&"
import script from "./SelectRow.vue?vue&type=script&lang=ts&"
export * from "./SelectRow.vue?vue&type=script&lang=ts&"
import style0 from "./SelectRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8b597e')) {
      api.createRecord('2a8b597e', component.options)
    } else {
      api.reload('2a8b597e', component.options)
    }
    module.hot.accept("./SelectRow.vue?vue&type=template&id=2a8b597e&", function () {
      api.rerender('2a8b597e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/inputs/SelectRow.vue"
export default component.exports